module.exports = {
  "FoodC_name_DiDi_Flash_TAPX": "DiDi Entrega",
  "sailing.c-api-intl.交易失败，请联系发卡行核实后重试": "Error de transacción. Inténtalo de nuevo después de verificar con el banco emisor.",
  "FoodC_recommended_Please_select_dJyk": "Elige un método de pago",
  "FoodB_5_Payment_Method_qlAx": "Método de pago",
  "sailing.launcher-xtx-center.订单已完成": "Soporte DiDi",
  "FoodB_DishesMerchants_Original_price_huUe": "Precio original",
  "sailing.c-api-intl.安全码无效，请核对信息后重试": "El código de seguridad es inválido, selecciona otros métodos de pago.",
  "FoodC_C_Cancel_Cqxt": "Cancelar",
  "sailing.c-api-intl.发卡行异常，请更换其他支付方式": "Hay algo mal con el banco emisor, por favor selecciona otros métodos de pago.",
  "DiDi_Food_(C)_confirm_receipt_goods_received_zfyG": "¿Recibiste tu pedido?",
  "sailing.b-api-intl.滴滴外卖": "DiDi Food",
  "sailing.c-api-intl.余额不足，请更换其他支付方式": "Saldo insuficiente. Por favor, selecciona otros métodos de pago.",
  "FoodC_update_Grand_total_JLev": "Total",
  "FoodC_001_The_WEB_Iizt": "La versión web no acepta actualmente el uso de PayPay. Para usar PayPay, descarga {{download}}",
  "FoodC_revision_Contact_customer_GIZy": "Contactar a Soporte DiDi",
  "sailing.c-api-intl.[提单页]_[总价]": "Total",
  "FoodB_modification_Confirmation_ehVU": "Aceptar",
  "soda-b-homepage-i18n---必须为%s字": "Debe contener %s caracteres.",
  "sailing.c-api-intl.无法识别卡信息，请核对信息后重试，或更换其他支付方式": "No se puede identificar la información. Inténtalo de nuevo después de verificar la información o seleccionar otros métodos de pago.",
  "FoodD_model_Upload_MoFF": "Subir",
  "soda-b-web-i18n---请选择": "Seleccionar",
  "FoodD_Compliance_Cancel_RytB": "Cancelar",
  "soda-act---卡类型": "Tipo de tarjeta",
  "FoodC_part3_Order_List_uPvS": "Pedidos",
  "sailing.c-api-intl.卡已失效，请更换其他支付方式": "La tarjeta no es válida, por favor, selecciona otros métodos de pago.",
  "sailing.launcher-xtx-center.支付成功": "Pago exitoso",
  "FoodC_busy_System_busy_QOvT": "El sistema está ocupado. Inténtalo de nuevo más tarde.",
  "FoodB_additional_Countless_STVD": "Sin datos",
  "soda-c-i18n---订单取消成功": "Pedido cancelado",
  "FoodC_perception_View_Uhmy": "Realizar compra",
  "sailing.c-api-intl.金额无效，请核对交易金额后重试": "Valor inválido, inténtalo después de verificarlo.",
  "soda-act---支付超时！": "Tiempo de espera de la solicitud agotado",
  "sailing.c-api-intl.[收藏]_[操作太快]": "Demasiados intentos. Inténtalo más tarde.",
  "FoodC_2_Payment_failed_cDAD": "Error en el pago",
  "soda-act---添加信用卡/借记卡": "Agregar tarjeta de crédito/débito",
  "sailing.c-api-intl.内部系统错误": "El sistema de pago se encuentra ocupado. Por favor, inténtalo más tarde",
  "FoodC_revision_Order_Details_aiDd": "Detalles del pedido",
  "FoodC_demand_Determination_wKQX": "Confirmar",
  "sailing.c-api-intl.交易失败，请核对信息后重试，或更换其他支付方式": "Error de transacción. Inténtalo de nuevo después de verificar la información o seleccionar otros métodos de pago.",
  "FoodC_IM_Search_no_GwBf": "No hay resultados",
  "sailing.c-api-intl.卡冻结，请更换其他支付方式": "La tarjeta está desactivada, por favor, selecciona otros métodos de pago.",
  "FoodD_up_Rule_description_dqPm": "Requisitos del paquete",
  "FoodC_Website_The_WEB_pBbW": "¡Lo sentimos! La versión web no admite el pago con {{pay_name}}. Para pagar con {{pay_name}}, por favor, descarga la aplicación.",
  "GDriver_Name_DiDi_Gsik": "DiDi",
  "FoodC_revision_Cancel_Order_qOSA": "Cancelar pedido",
  "soda-b-homepage-i18n---最多不能超过%s个字": "No puede exceder los %s caracteres.",
  "soda-act---复制成功": "Copiado",
  "sailing.c-api-intl.交易失败，请稍后重试": "Error de transacción. Inténtalo más tarde."
}